import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

export default async function management ({ to, store }) {
  const authToken = store.state.authToken || await store.dispatch('loadAuthToken', null, { root: true })

  // redirect to public screen if user is not logged in
  if (!authToken) return { path: '/' }

  let user = store.getters['users/me']

  // wait for user load
  if (!user) {
    await store.dispatch('users/getSelf', authToken)
    user = store.getters['users/me']
  }

  // redirect to new page if user has no 'manage' permission
  const hasSomeManagePermission = user && (GlobalPrototypes.can('view-timetable-planner', user) || GlobalPrototypes.can('manage-users', user) || GlobalPrototypes.can('view-all-channels', user))
  if (hasSomeManagePermission || to.name === GlobalPrototypes.defaultRoute().name) return
  return {...GlobalPrototypes.defaultRoute()}
}
